const Queries = {
  Dashboard: `
        query Dashboard {
            dashboard {
                process {
                    running pid started_at status last_exit_code running_count
                    rotation_active rotation_batch_index rotation_batch_count
                    rotation_next_at rotation_batch_size rotation_shift_minutes
                    rotation_wave
                }
                accounts {
                    username password has_password proxy proxy_label proxy_exit_ip has_proxy has_session
                    enabled paused ai_paused warmup_enabled session_status last_error last_login_at
                    known_followers_count followers_seeded followers_new_today
                    replied_threads_count
                    conversation_count last_activity_at pending_outbound_count
                    messages_total replies_last_day
                    sends_last_hour sends_last_day failed_outbound_count
                    unread_count
                    ig_username first_name last_name city country model_id
                    login_count_total login_count_today ig_follower_count avatar_url
                    watcher_status last_inbox_tick_at last_followers_tick_at last_requests_tick_at
                    progress_detail contacts_rescan_status
                    inbox_tab_ok followers_tab_ok requests_tab_ok
                    last_inbox_latency_ms last_followers_latency_ms last_requests_latency_ms
                    watcher_sends_ok watcher_sends_fail last_ban_at
                    timezone locale signup_email_string signup_phone_string process_running process_pid
                    ai {
                        response_mode delay_min_minutes delay_max_minutes provider model
                        api_key has_api_key temperature system_prompt message_rule_prompt
                        welcome_prompt welcome_template welcome_use_ai
                        last_msg_activated last_msg_limit last_msg_prompt final_message_enabled final_message_after_count final_message_idle_hours final_message_template link_pool
                        voice_id voice_api_key has_voice_api_key voice_replies_enabled
                        poll_interval_min_ms poll_interval_max_ms
                        max_threads_per_cycle_min max_threads_per_cycle_max
                        max_threads_per_day_min max_threads_per_day_max
                max_messages_per_thread_per_day
                        min_reply_gap_min_ms min_reply_gap_max_ms
                        followers_enabled followers_follow_back followers_schedule
                        followers_max_per_cycle_min followers_max_per_cycle_max
                        followers_scan_limit_min followers_scan_limit_max
                        quiet_hours_enabled quiet_hours_start quiet_hours_end quiet_hours_tz
                        ignore_keywords blocklist_usernames skip_group_threads
                        media_replies_enabled auto_accept_message_requests
                        browser_mode browser_engine visible_browser ws_wake_enabled
                        ws_wake_delay_min_sec ws_wake_delay_max_sec
                        stories_enabled stories_per_day_min stories_per_day_max
                        posts_enabled posts_per_day_min posts_per_day_max
                        gallery_categories { id label }
                    }
                }
                logs { at line account level }
                challenge { pending id account type channel destination message requested_at code_submitted expires_at }
                config {
                    max_concurrent_sessions
                    rotation_enabled
                    rotation_batch_size
                    rotation_shift_minutes
                    hide_suspended_accounts
                    browser_max_width
                    browser_max_height
                    blocklist_usernames
                }
                health {
                    sends_last_hour sends_last_day failed_last_day failed_last_hour pending_outbound
                    accounts_total accounts_enabled accounts_paused accounts_need_login
                    accounts_banned
                    quiet_hours_active
                    challenge_age_sec warnings
                }
            }
        }
        `,
  Followers: `
        query Followers($account: String!, $limit: Int) {
            followers(account: $account, limit: $limit) {
                total_known seeded contacts_rescan_status
                followers { username first_seen_at ignored }
            }
        }
        `,
  ReplyMedia: `
        query ReplyMedia($account: String) {
            reply_media(account: $account) {
                id account filename mime_type size description category_id created_at media_url
            }
        }
        `,
  PublishMedia: `
        query PublishMedia($account: String!, $kind: String) {
            publish_media(account: $account, kind: $kind) {
                id account kind relative_path filename mime_type size caption used_at created_at media_url
            }
        }
        `,
  Conversations: `
        query Conversations($account: String!, $filter: ConversationFilter, $search: String, $limit: Int, $offset: Int) {
            conversations(account: $account, filter: $filter, search: $search, limit: $limit, offset: $offset) {
                account thread_id title peer_username href unread manual_mode ai_prompt
                updated_at last_message_at last_preview last_from
                has_failed_outbound is_follower_only avatar_url
            }
        }
        `,
  Conversation: `
        query Conversation($account: String!, $thread_id: String!) {
            conversation(account: $account, thread_id: $thread_id) {
                account thread_id title peer_username href unread manual_mode ai_prompt
                updated_at last_message_at last_preview last_from
                has_failed_outbound is_follower_only avatar_url has_older_messages
                messages { id from text at source media_name media_url media_kind outbound_id outbound_status send_at }
            }
        }
        `,
  OlderMessages: `
        query OlderMessages($account: String!, $thread_id: String!, $before_at: String!, $before_id: String, $limit: Int) {
            older_messages(account: $account, thread_id: $thread_id, before_at: $before_at, before_id: $before_id, limit: $limit) {
                id from text at source media_name media_url media_kind outbound_id outbound_status send_at
            }
        }
        `,
  Outbound: `
        query Outbound($account: String, $limit: Int, $status: OutboundStatus) {
            outbound(account: $account, limit: $limit, status: $status) {
                id account thread_id peer_username text media_path media_name has_media created_at status error sent_at
            }
        }
        `,
  Health: `
        query Health {
            health {
                sends_last_hour sends_last_day failed_last_day failed_last_hour pending_outbound
                accounts_total accounts_enabled accounts_paused accounts_need_login
                accounts_banned
                quiet_hours_active
                challenge_age_sec warnings
            }
        }
        `,
  Audit: `
        query Audit($account: String, $limit: Int) {
            audit(account: $account, limit: $limit) {
                at actor action account detail
            }
        }
        `,
  WarmupEvents: `
        query WarmupEvents($account: String, $limit: Int) {
            warmup_events(account: $account, limit: $limit) {
                at account kind reel_url reel_id target_username keyword comment_text detail
            }
        }
        `,
  Logs: `
        query Logs($account: String, $limit: Int) {
            logs(account: $account, limit: $limit) {
                at line account level
            }
        }
        `,
  Models: `
        query Models {
            models {
                id label first_name city country gallery_count cover_url
            }
        }
        `,
  Model: `
        query Model($id: String!) {
            model(id: $id) {
                id label first_name last_name city country
                system_prompt message_rule_prompt welcome_prompt welcome_template welcome_use_ai
                last_msg_activated last_msg_limit last_msg_prompt final_message_enabled final_message_after_count final_message_idle_hours final_message_template link_pool
                voice_id voice_replies_enabled
                delay_min_minutes delay_max_minutes
                poll_interval_min_ms poll_interval_max_ms
                max_threads_per_cycle_min max_threads_per_cycle_max
                max_threads_per_day_min max_threads_per_day_max
                max_messages_per_thread_per_day
                min_reply_gap_min_ms min_reply_gap_max_ms
                followers_enabled followers_follow_back followers_schedule
                followers_max_per_cycle_min followers_max_per_cycle_max
                followers_scan_limit_min followers_scan_limit_max
                quiet_hours_enabled quiet_hours_start quiet_hours_end quiet_hours_tz
                ignore_keywords blocklist_usernames skip_group_threads
                media_replies_enabled auto_accept_message_requests
                browser_mode browser_engine visible_browser ws_wake_enabled
                ws_wake_delay_min_sec ws_wake_delay_max_sec
                stories_enabled stories_per_day_min stories_per_day_max
                posts_enabled posts_per_day_min posts_per_day_max
                gallery_categories { id label }
                gallery { file category_id description filename mime_type media_url }
                stories { file category_id description filename mime_type media_url }
                posts { file category_id description filename mime_type media_url }
            }
        }
        `,
  AccountSources: `
        query AccountSources {
            account_sources {
                proxies { id kind filename bytes updated_at }
                emails { id kind filename bytes updated_at }
            }
        }
    `,
  Phones: `
        query Phones {
            phones {
                id model address connected connected_at
                accessibility proxy account ig
            }
        }
    `,
};

export default Queries;
